import { color, rem, spacing, radius, border } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  css`
    :host {
      box-sizing: border-box;
      display: block;
      --chevron-color: ${color('blue', 600)};
      --hover-color: ${color('grey', 100)};
      --summary-background: ${color('white')};
      --text-color: ${color('black')};
      --icon-color: ${color('grey', 600)};
    }

    :host([active]) {
      --chevron-color: ${color('white')};
      --hover-color: ${color('blue', 800)};
      --summary-background: ${color('blue', 600)};
      --text-color: ${color('white')};
      --icon-color: ${color('white')};
    }

    :host([secondary]) {
      --chevron-color: ${color('black')};
      --hover-color: ${color('grey', 200)};
      --text-color: ${color('black')};
      --icon-color: ${color('black')};
    }

    :host([secondary][active]) {
      --hover-color: ${color('grey', 300)};
      --summary-background: ${color('grey', 300)};
      --text-color: ${color('black')};
      --icon-color: ${color('black')};
    }

    :where(a-accordion) {
      &:not(.toc-item--has-actions) {
        &::part(summary):hover {
          background: var(--hover-color);
        }
      }

      &::part(summary) {
        background: var(--summary-background);
        color: var(--text-color);
      }

      &.toc-item--has-actions::part(summary) {
        border-radius: ${radius('medium')};
        display: flex;
        gap: 0;
        overflow: hidden;
        padding: 0;
      }

      &.toc-item--has-actions::part(chevron) {
        align-self: stretch;
        display: flex;
        inline-size: ${rem(40)};
        justify-content: center;
      }

      &.toc-item--has-actions::part(chevron):hover {
        background: var(--hover-color);
      }

      [slot='summary'] {
        display: flex;
        font-weight: 600;
        justify-content: space-between;
      }
    }

    :where(.marker-container) {
      display: flex;
      gap: ${rem(6)};
    }

    :where(.toc-item-wrapper) {
      background: var(--summary-background);
      border-radius: ${radius('medium')};
      color: var(--text-color);
      display: flex;
      justify-content: space-between;
      overflow: hidden;

      &:not(.toc-item--has-actions):not(:has(a-toc-action)) {
        padding: var(--toc-item-wrapper-padding);
      }

      :host([secondary]) {
        border: ${border(1, 'white', 100, 'solid')};
        border-radius: ${radius('large')};
      }

      :host([secondary][active]) {
        --summary-background: ${color('grey', 300)};
        border: ${border(1, 'grey', 400, 'solid')};
        border-radius: ${radius('large')};
      }

      :host([secondary][collapsed]) {
        inline-size: ${rem(50)};
        margin: 0 auto;
      }
    }

    :where(a-toc-action:first-of-type)::part(button) {
      border-end-start-radius: ${radius('medium')};
      border-start-start-radius: ${radius('medium')};
    }

    :where(a-toc-action:last-of-type)::part(button) {
      border-end-end-radius: ${radius('medium')};
      border-start-end-radius: ${radius('medium')};
    }

    :host:has(a-accordion) {
      padding-block: ${spacing(75)};

      &([active]) {
        & a-accordion::part(summary) {
          border-radius: ${radius('large')};
        }
      }
    }
  `,
];
